import { request } from './http'

export function submitContactInquiry(data) {
  return request('/api/contact', {
    method: 'POST',
    body: JSON.stringify(data)
  })
}

export function fetchInquiries(keyword = '') {
  const q = keyword ? `?keyword=${encodeURIComponent(keyword)}` : ''
  return request(`/api/admin/inquiries${q}`)
}

export function fetchInquiry(id) {
  return request(`/api/admin/inquiries/${id}`)
}

export function markInquiryRead(id, isRead = true) {
  return request(`/api/admin/inquiries/${id}/read`, {
    method: 'PATCH',
    body: JSON.stringify({ is_read: isRead })
  })
}

export function deleteInquiry(id) {
  return request(`/api/admin/inquiries/${id}`, {
    method: 'DELETE'
  })
}
